import React from "react";

import styles from "./units-list-popover.module.scss";
import { UnitObject } from "@common/types/tree-types";

interface UnitsListPopoverPropTypes {
  popoverOnClickCallback: (value: UnitObject) => void;
  matchingUnitsArray: UnitObject[] | undefined;
}

const cssClassName = "units-list-popover";

export const UnitsListPopover = ({
  popoverOnClickCallback,
  matchingUnitsArray,
}: UnitsListPopoverPropTypes) => {
  return (
    <div className={styles[cssClassName]}>
      {matchingUnitsArray &&
        matchingUnitsArray.map((unit) => (
          <button
            key={unit.code}
            onClick={() => popoverOnClickCallback(unit)}
            className={styles[`${cssClassName}__unit-line`]}
          >
            {unit.display_name} - {unit.description}
          </button>
        ))}
    </div>
  );
};
